export default "__VITE_ASSET__b09a6a6b__"